import { useEffect, type RefObject } from 'react';

// 모듈 레벨 변수로 외부 접근 가능하게
let layoutRefInstance: RefObject<HTMLDivElement> | null = null;
let previousScrollTopInstance: number = 0;

// 외부에서 직접 접근 가능한 함수 (hook이 아님)
export function getInsightLayoutRef(): RefObject<HTMLDivElement> | null {
  return layoutRefInstance;
}

export function getInsightScrollTop(): number {
  return previousScrollTopInstance;
}

export function setInsightScrollTop() {
  const scrollTop = getInsightLayoutRef()?.current?.scrollTop ?? 0;
  previousScrollTopInstance = scrollTop;
}

export function cleartInsightScrollTop() {
  previousScrollTopInstance = 0;
}

// Context Provider에서 호출할 함수
export function setInsightLayoutRef(ref: RefObject<HTMLDivElement> | null) {
  layoutRefInstance = ref;
}

export function useRestoreScroll() {
  useEffect(() => {
    const layoutRef = getInsightLayoutRef();
    const previousScrollTop = getInsightScrollTop();
    if (layoutRef && previousScrollTop) {
      layoutRef.current?.scrollTo({ top: previousScrollTop });
      cleartInsightScrollTop();
    }
  }, []);
}

export function useSetInsightScrollContainer(ref: RefObject<HTMLDivElement> | null) {
  useEffect(() => {
    setInsightLayoutRef(ref);
    return () => {
      setInsightLayoutRef(null);
    };
  }, [ref]);
}
